var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnglish(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.811 20.624h7.5c.927 0 1.714-.21 2.368-.574l-9.868-5.886v6.46zm12.028-3.652c.107-.476.161-.981.161-1.505v-2.343h-6.614l6.45 3.848M.165 3.637A6.86 6.86 0 000 5.156V7.5H6.64L.164 3.637zM12.187 0h-7.5c-.92 0-1.702.206-2.353.565l9.853 5.878V0zM2.364 20.073c.645.35 1.417.55 2.323.55h7.5v-6.41l-9.823 5.86zM0 13.124v2.344c0 .54.057 1.06.17 1.548l6.524-3.892H0zM27.708.588C27.05.214 26.251 0 25.311 0h-7.5v6.492L27.708.588zm2.29 6.912V5.156c0-.513-.053-1.007-.155-1.475L23.442 7.5h6.556z",
    fill: "#2E3192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.442 7.5l6.4-3.82c-.293-1.342-1.007-2.453-2.134-3.092l-9.897 5.904V0h-.937v8.437h13.124V7.5h-6.556zM0 12.187v.937h6.694L.17 17.016c.31 1.338 1.046 2.437 2.194 3.057l9.823-5.86v6.41h.937v-8.436H0zm29.998 0H16.874v8.437h.937v-6.46l9.868 5.887c1.135-.632 1.858-1.737 2.158-3.078l-6.45-3.849h6.611v-.937zM12.187 0v6.443L2.334.565C1.194 1.193.467 2.297.164 3.637L6.639 7.5H0v.937h13.124V0h-.937z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.874 8.437V0h-3.75v8.437H0v3.75h13.124v8.437h3.75v-8.437h13.124v-3.75H16.874z",
    fill: "#BE1E2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.283 7.5L.885 1.89c-.202.3-.364.63-.498.98L8.143 7.5h2.138m19.29 10.354l-7.88-4.73h-2.182l9.52 5.727c.221-.308.404-.643.543-.996M28.46 1.121L17.797 7.5h2.165l9.201-5.508a3.177 3.177 0 00-.703-.871zM.85 18.69c.21.32.464.611.754.864l10.612-6.43h-2.138L.85 18.69z",
    fill: "#BE1E2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default ForwardRef;